(function () {
    'use strict';
    EO_NoDataController.$inject = ['$scope', '$attrs', '$element'];

    function EO_NoDataController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.initDefault = initDefault;
        initDefault();

        function initDefault() {

            if (!$ctrl.message)
                $ctrl.message = 'اطلاعاتی جهت نمایش موجود نیست';

        }


    }


    var EO_NoData = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/no-data/eyeson.no-data.template.html',
        controller: EO_NoDataController,
        bindings: {
            message: "=?"
        }


    };

    angular
        .module('tikonApp')
        .component('eoNoData', EO_NoData)


})();

